export const SET_FLIGHT_SUCCESS = 'SET_FLIGHT_SUCCESS';
export const SET_FLIGHT_SELECTED = 'SET_FLIGHT_SELECTED';
export const SET_FLIGHT_LIGHTBOXDEST = 'SET_FLIGHT_LIGHTBOXDEST';
